const getPath = (node) => {
  if (node.prev) {
    return getPath(node.prev).concat([{ metro: node.metro, latency: node.latency }]);
  } else {
    return [{ metro: node.metro, latency: node.latency }];
  }
};

export default getPath;
